import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { Typography, Grid, InputAdornment } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { IconButton } from 'shared/ui/IconButton';
import { InputField } from 'shared/ui/InputField';
import { InboundEmail } from 'entities/inbound-emails/types';
import { EditFormType, EditSchema } from './type';

type EditFormProps = {
	emailDetails: InboundEmail;
	onSubmit: ({ id, data }: { id: string; data: EditFormType }) => void;
};

const EditForm: FC<EditFormProps> = ({ emailDetails, onSubmit }) => {
	const [edit, setEdit] = useState(false);
	const { t } = useTranslation();

	const handleSubmit = (values: EditFormType) => {
		onSubmit({
			id: emailDetails._id,
			data: values,
		});
		setEdit(false);
	};

	if (!edit) {
		return (
			<>
				<Typography variant={'body2'} color={ColorPalette.astronaut}>
					{emailDetails.imgMinResolution || '- '}px
				</Typography>
				<IconButton iconId="edit" onClick={() => setEdit(true)} />
			</>
		);
	}

	return (
		<Formik
			initialValues={{
				imgMinResolution: emailDetails.imgMinResolution,
			}}
			validationSchema={EditSchema}
			onSubmit={handleSubmit}
		>
			<Form>
				<Grid container gap={2} alignItems="center">
					<InputField
						name={'imgMinResolution'}
						type="number"
						label={''}
						placeholder={t('shared_texts.enter_number')}
						endAdornment={
							<InputAdornment position="end">
								<Typography sx={{ color: ColorPalette.baliHai }}>px</Typography>
							</InputAdornment>
						}
						sx={{ width: '60%', marginBottom: '0' }}
					/>

					<IconButton type={'submit'} iconId="save" />
					<IconButton
						iconId="close_round"
						onClick={() => setEdit(false)}
						sxIcon={{
							color: ColorPalette.violetRed,
						}}
					/>
				</Grid>
			</Form>
		</Formik>
	);
};

export default EditForm;
